import { createSelector } from "@reduxjs/toolkit";

export const ownersListState = (state) => state.ownersList;

export const OwnersListSelectors = createSelector(ownersListState, (state) => state);
